require.register("app/product/stat/NetSaleView", function(exports, require, module){
  $0
  
});

